import {supabase} from '../../../../../services/supabaseClient'

export const getZones = async () => {
  const {data, error} = await supabase.from('zones').select('*').order('nombre')

  if (error) throw error

  return data
}

export const getMyProfile = async () => {
  const {
    data: {user},
  } = await supabase.auth.getUser()

  if (!user) throw new Error('No user')

  const {data, error} = await supabase.from('profiles').select('*').eq('id', user.id).single()

  if (error) throw error

  return data
}

export const createZone = async (payload: any) => {
  const {error} = await supabase.from('zones').insert(payload)

  if (error) throw error
}

export const updateZone = async (id: number, payload: any) => {
  const {error} = await supabase.from('zones').update(payload).eq('id', id)

  if (error) throw error
}

export const toggleZoneStatus = async (id: number, activa: boolean) => {
  const {error} = await supabase
    .from('zones')
    .update({
      activa: !activa,
    })
    .eq('id', id)

  if (error) throw error
}
